<div class="create-shell mt-5">
  <section class="create-acfs">
    <div class="acfs-copy">
      <h1>สร้างใบขาย</h1>
      <p>ดึงสินค้าจากสต็อกเพื่อสร้าง QR ให้ผู้ซื้อสแกน</p>
    </div>
    <img class="acfs-new-img" src="/assets/images/empty-basket.png" alt="">
  </section>

  @if (!store.businessesLoaded()) {
    <section class="product-list-card product-list-skeleton" aria-busy="true" aria-label="กำลังโหลด">
      <div class="skeleton-label"></div>
      @for (item of [1, 2, 3]; track item) {
        <article class="product-skeleton-row">
          <div class="product-skeleton-head">
            <div class="skeleton-copy">
              <div class="skeleton-line skeleton-title"></div>
              <div class="skeleton-line skeleton-sub"></div>
            </div>
            <div class="skeleton-badge"></div>
            <div class="skeleton-icon"></div>
          </div>
        </article>
      }
    </section>
  } @else if (store.selectedBusinessId() == null) {
    <section class="state-band">
      <div class="empty-state">
        <strong>กรุณาเลือกธุรกิจก่อนสร้างใบขาย</strong>
        <p><a class="fw-semibold" routerLink="/trade">กลับไปรายการซื้อ-ขาย</a></p>
      </div>
    </section>
  } @else {
    @if (fromRecordId(); as recordId) {
      <div class="sell-from-harvest" role="status">
        <span class="harvest-notice-icon" aria-hidden="true">
          <i class="bi bi-check-lg"></i>
        </span>
        <div class="harvest-notice-copy">
          <strong>บันทึกผลผลิตแล้ว</strong>
<!--          <span>สร้างใบขายให้ผู้ซื้อสแกนได้เลย (แก้จำนวนได้)</span>-->
          <a [routerLink]="[tradeBase, recordId]">ยังไม่ขายตอนนี้ ดูรายการ <i class="bi bi-arrow-right" aria-hidden="true"></i></a>
        </div>
      </div>
    }

    <section class="detail-card">
      @if (store.selectedBusiness(); as business) {
        <div class="business-summary" aria-label="ธุรกิจที่ขาย">
          <i class="bi bi-shop" aria-hidden="true"></i>
          <div>
            <div class="business-summary-title">{{ business.title }}</div>
            <div class="business-summary-meta">
              <span class="text-secondary small">ขายในนามธุรกิจนี้</span>
            </div>
          </div>
        </div>
      }

      @for (line of lines(); track $index; let lineIndex = $index) {
        <div class="form-section">
          <div class="section-label">สินค้าที่ขาย</div>
          <div class="harvest-box">
            <label class="harvest-input">
              <span class="ui-require">ชื่อสินค้าที่ขาย</span>
              <input [id]="'sell-product-name-' + lineIndex" type="text" class="form-control"
                     [(ngModel)]="line.productName" [name]="'productName' + lineIndex"
                     (ngModelChange)="onProductNameInput()" placeholder="เช่น ทุเรียนหมอนทอง"
                     [class.is-invalid]="submitted() && !line.productName.trim()">
            </label>
            @if (submitted() && !line.productName.trim()) {
              <small class="invalid-feedback d-block text-danger">กรุณาระบุชื่อสินค้าที่ขาย</small>
            }
          </div>
        </div>

        <div class="form-section">
          <div class="section-label">ดึงจากสต็อก</div>
          @for (row of line.rows; track $index; let rowIndex = $index) {
            <div class="harvest-box pool-box">
              <label class="harvest-input">
                <span>กองสินค้า</span>
                <select class="form-select" [id]="'sell-pool-' + lineIndex + '-' + rowIndex"
                        [ngModel]="row.poolName" [name]="'pool' + lineIndex + '-' + rowIndex"
                        (ngModelChange)="onPoolChange(lineIndex, rowIndex, $event)">
                  @for (pool of stock(); track pool.productName) {
                    <option [value]="pool.productName"
                            [disabled]="isPoolTaken(lineIndex, rowIndex, pool.productName ?? '')">
                      {{ pool.productName }} ({{ formatQuantityWithUnit(pool.quantity, unit) }})
                    </option>
                  }
                </select>
              </label>
              <div class="quantity-unit-row">
                <label class="harvest-input">
                  <span class="ui-require">จำนวน</span>
                  <input [id]="'sell-quantity-' + lineIndex + '-' + rowIndex" type="text"
                         class="form-control" inputmode="decimal" placeholder="0"
                         [(ngModel)]="row.quantity" [name]="'quantity' + lineIndex + '-' + rowIndex"
                         (ngModelChange)="onQuantityInput(lineIndex, rowIndex)"
                         [class.is-invalid]="rowExceedsStock(lineIndex, rowIndex)
                           || (submitted() && !row.quantity)">
                </label>
                <label class="harvest-input">
                  <span>หน่วย</span>
                  <input type="text" class="form-control unit-readonly" [value]="unit" readonly tabindex="-1">
                </label>
              </div>
              @if (row.poolName) {
                <small class="field-hint">คงเหลือ {{ formatQuantityWithUnit(availableStock(row.poolName), unit) }}</small>
              }
              @if (rowExceedsStock(lineIndex, rowIndex)) {
                <small class="invalid-feedback d-block text-danger">จำนวนที่ขายเกินสต็อกที่มี</small>
              } @else if (submitted() && !row.quantity) {
                <small class="invalid-feedback d-block text-danger">ต้องมากกว่า 0</small>
              }
              <div class="pool-row-actions">
                <button type="button" class="btn btn-outline-secondary btn-sm"
                        [id]="'sell-all-' + lineIndex + '-' + rowIndex"
                        [disabled]="!row.poolName || availableStock(row.poolName) <= 0"
                        title="ใส่จำนวนทั้งหมดที่มีในกองนี้"
                        (click)="useAllStock(lineIndex, rowIndex)">ทั้งหมด</button>
                @if (line.rows.length > 1) {
                  <button type="button" class="btn btn-outline-danger btn-sm"
                          (click)="removeRow(lineIndex, rowIndex)">ลบ</button>
                }
              </div>
            </div>
          }

          <div class="pool-actions">
            @if (stock().length > line.rows.length) {
              <button type="button" class="btn btn-default btn-sm" (click)="addRow(lineIndex)">
                <i class="bi bi-plus-lg" aria-hidden="true"></i> ดึงจากกองอื่น
              </button>
            }
            <span class="text-secondary small">
              รวมรายการนี้ {{ formatQuantityWithUnit(lineTotal(lineIndex), unit) }}
            </span>
          </div>
        </div>
      }

      <div class="form-section">
        <div class="section-label">หมายเหตุ</div>
        <div class="harvest-box">
          <label class="harvest-input">
            <span>หมายเหตุ</span>
            <textarea id="sell-note" class="form-control" rows="2" [(ngModel)]="note" name="note"></textarea>
          </label>
        </div>
        <small class="field-hint">เมื่อสร้างใบขายแล้ว ระบบจะตัดสต็อกทันทีและสร้าง QR ให้ผู้ซื้อสแกนเพื่อรับสินค้าตามจำนวนนี้</small>
      </div>

      <div class="submit-row submit-actions">
        <button type="button" class="btn btn-primary flex-grow-1" [disabled]="saving()" (click)="submit()">
          @if (saving()) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          }
          สร้างใบขาย
        </button>
        <a class="btn btn-outline-secondary" routerLink="/trade">ยกเลิก</a>
      </div>
    </section>
  }
</div>
